const REPLY_POINTS = 100; // PRIORITY_RULES.reply: a waiting client comes first
/** The rows the ranked needs-you list held (board.ts issues): a needs-you row on a real record, or a missing side a client reply waits on. */
export function isIssueRow(r) {
    // 2026-10-09 (gap audit): a missing side a person must act on stays on the issues list until it is resolved (40 on 8-14 day cases
    // dropped off the 7-day board), and a letter the system could not send is an issue too (151 sat as a small label on opened rows)
    return r.status === 'need' || !!r.lorAsk;
}
/** the hit-and-run decision is the advocate's now (Neila 2026-10-08); older rows without a stage are the decision */
export const hitRunConfirm = (r) => !!r.hitRun && (r.hitRun.stage ?? 'confirm') === 'confirm';
const CODES = /^(SI|ORIF|ACDF|PL\b|Tier\b)/;
function word(label) {
    if (label === 'surgery field')
        return 'Surgery';
    if (CODES.test(label))
        return label;
    return label.charAt(0).toUpperCase() + label.slice(1);
}
export function urgentTag(r, priority) {
    if (!isIssueRow(r))
        return null;
    const reasons = [];
    let score = 0;
    // the case's "client replied" chip comes from any row; only the row the reply waits on is urgent for it
    if (r.replies?.some((x) => x.waiting)) {
        reasons.push('Client replied');
        score += REPLY_POINTS;
    }
    for (const c of priority?.chips ?? []) {
        if (c.key === 'reply')
            continue;
        reasons.push(word(c.label));
        score += c.points;
    }
    if (r.policeHold)
        reasons.push('Client at fault?');
    if (hitRunConfirm(r))
        reasons.push('Hit and run');
    return reasons.length ? { label: reasons[0], reasons, score } : null;
}
/** How urgent a case is: its most urgent row's points and label, every urgent row's reasons (strongest row first, no repeats), and
 *  `since` = the longest wait among its urgent rows. The list shows this one tag per case, next to the client's name. */
export function matterUrgency(m) {
    const tags = [];
    for (const r of m.rows) {
        const t = urgentTag(r, m.priority);
        if (t)
            tags.push({ t, since: r.waitingSince });
    }
    if (!tags.length)
        return null;
    const order = [...tags].sort((a, b) => b.t.score - a.t.score);
    const reasons = [...new Set(order.flatMap((x) => x.t.reasons))];
    const since = tags.reduce((a, x) => (ms(x.since) < ms(a) ? x.since : a), tags[0].since);
    return { score: order[0].t.score, since, tag: { label: order[0].t.label, reasons, score: order[0].t.score } };
}
const ms = (iso) => Date.parse(iso.replace(/\+0000$/, 'Z'));
/** Urgent cases first (most points, then the longest wait); the rest keep their order. Returns a new array. */
export function urgentFirst(matters) {
    const scored = matters.map((m, i) => ({ m, i, u: matterUrgency(m) }));
    const urgent = scored.filter((x) => x.u).sort((a, b) => b.u.score - a.u.score || ms(a.u.since) - ms(b.u.since) || a.i - b.i);
    return [...urgent, ...scored.filter((x) => !x.u)].map((x) => x.m);
}
/** All open issues, "most important first": urgent rows lead (most points, then the longest wait), the rest keep the given order.
 *  Row by row, so a case's reply never lifts its other rows (the same rule as the Urgent column). Returns a new array. */
export function urgentIssuesFirst(issues) {
    const scored = issues.map((x, i) => ({ x, i, t: urgentTag(x.row, x.matter.priority) }));
    const urgent = scored.filter((s) => s.t).sort((a, b) => b.t.score - a.t.score || ms(a.x.row.waitingSince) - ms(b.x.row.waitingSince) || a.i - b.i);
    return [...urgent, ...scored.filter((s) => !s.t)].map((s) => s.x);
}
//# sourceMappingURL=urgent.js.map